exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.i(require("-!../../node_modules/css-loader/index.js?modules&minimize&importLoaders=1!../../node_modules/postcss-loader/index.js!../css/variables.css"), "");

// module
exports.push([module.id, "._2Dr5PkJBPXa7DGWtACVIDO{background:var(--colorBlack);color:var(--colorWhite)}._2Dr5PkJBPXa7DGWtACVIDO h1{font-size:2.75rem}._3nvcj0QizdESZG5Vdf38mv{border-bottom:3px solid var(--colorWhite)}@media (--small){._2Dr5PkJBPXa7DGWtACVIDO h1{font-size:1.7142rem}._3nvcj0QizdESZG5Vdf38mv{border-width:2px}}", ""]);

// exports
exports.locals = {
	"intro": "_2Dr5PkJBPXa7DGWtACVIDO",
	"link": "_3nvcj0QizdESZG5Vdf38mv"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&minimize&importLoaders=1!./~/postcss-loader!./src/pages/styles.module.css
// module id = ./node_modules/css-loader/index.js?modules&minimize&importLoaders=1!./node_modules/postcss-loader/index.js!./src/pages/styles.module.css
// module chunks = 13994203391546835000